// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"26a3624f","833":"8073fbf6"}[chunkId] + ".chunk.js";
};